import { render, staticRenderFns } from "./cpt-chart-pie.vue?vue&type=template&id=1d08ec6a&scoped=true&"
import script from "./cpt-chart-pie.vue?vue&type=script&lang=js&"
export * from "./cpt-chart-pie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d08ec6a",
  null
  
)

export default component.exports